<template>
  <div>
    <b-form-group :label="label">
      <validation-provider
        #default="{ errors }"
        :rules="{ required: requireInternal }"
        name="Equipe"
      >
        <v-select
          ref="equipeSelect"
          v-model="internalValue"
          :options="equipes"
          label="nome"
          :clearable="false"
          :multiple="multiple"
          :disabled="disabled"
          @close="onTouch"
          @open="carregarEquipes"
          @search-change="carregarEquipesFiltradas"
          @input="enviarParaPai"
          @change="enviarParaPaiChange"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import { required } from '@validations'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'EquipeSelect',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => {},
    },
    label: {
      type: String,
      default: 'Equipe',
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      equipes: [],
      equipePrimeiroAcesso: true,
      nomeEquipe: '',
      multipleChanged: false,
      // Lista fixa simulando retorno da API
      allEquipes: [
        {
          id: 1,
          nome: 'Amarela',
        },
        {
          id: 2,
          nome: 'Azul',
        },
        {
          id: 3,
          nome: 'Branca',
        },
        {
          id: 4,
          nome: 'Cinza',
        },
        {
          id: 5,
          nome: 'Laranja',
        },
        {
          id: 6,
          nome: 'Roxa',
        },
        {
          id: 7,
          nome: 'Verde',
        },
        {
          id: 9,
          nome: 'Vermelha',
        },
        {
          id: 10,
          nome: 'Rosa',
        },
        {
          id: 11,
          nome: 'MEI',
        },
        {
          id: 12,
          nome: 'Não é Cliente',
        },
      ],

    }
  },
  computed: {
    internalValue: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    isInvalido() {
      // O original usava 'invalido', mas não foi passado como prop
      // Se você quiser usar, basta definir uma prop 'invalido'
      return false
    },
    requireInternal() {
      return this.require
    },
  },
  watch: {
    multiple(val, oldVal) {
      if (val !== oldVal) {
        this.multipleChanged = true
      }
    },
    value(val, oldVal) {
      if (val !== oldVal) {
        this.internalValue = val
      }
    },
  },
  methods: {
    carregarEquipes() {
      // Carrega apenas no primeiro acesso
      if (this.equipePrimeiroAcesso) {
        this.equipes = this.allEquipes
        this.equipePrimeiroAcesso = false
      }
    },
    carregarEquipesFiltradas(nomeEquipe) {
      // Filtra localmente no array allEquipes (sem chamar a API)
      this.nomeEquipe = nomeEquipe
      this.equipes = this.allEquipes.filter(eq => eq.nome.toLowerCase().includes(this.nomeEquipe.toLowerCase()))
    },
    propagarParaFilho() {
      this.$refs.equipeSelect.focus()
    },
    enviarParaPai() {
      // Respeita a mudança de 'multiple'
      if (this.multipleChanged) {
        if (this.multiple) {
          this.internalValue = this.value
        } else {
          this.internalValue = []
        }
        this.multipleChanged = false
      }
      // Dispara eventos
      this.$emit('select', this.internalValue || null)
      this.$emit('input', this.internalValue || null)
      this.$emit('change', this.internalValue || null)
    },
    enviarParaPaiChange() {
      if (this.multipleChanged) {
        if (this.multiple) {
          this.internalValue = this.value
        } else {
          this.internalValue = []
        }
        this.multipleChanged = false
      }
      this.$emit('change', this.internalValue || null)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.internalValue = []
    },
  },
}
</script>
